import script from "./trust.vue?vue&type=script&setup=true&lang=js"
export * from "./trust.vue?vue&type=script&setup=true&lang=js"

import "./trust.vue?vue&type=style&index=0&id=0d18cb3b&lang=scss&scoped=true"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d18cb3b"]])

export default __exports__